export function convertProgressSize(sizeInBytes: number): string | number {
  const GB = Math.pow(1024, 3);
  const MB = Math.pow(1024, 2);

  type RoundingCalculation = (bytes: number, unit: number) => string | number;
  const nearestHundreths: RoundingCalculation = (bytes, unit) => (Math.floor((bytes / unit) * 100) / 100).toFixed(2);
  const nearestTenths: RoundingCalculation = (bytes, unit) => (Math.floor((bytes / unit) * 10) / 10).toFixed(1);
  const nearestWhole: RoundingCalculation = (bytes, unit) => Math.floor(bytes / unit);

  if (sizeInBytes === 0) {
    return '0 MB';
  }
  if (sizeInBytes >= GB) {
    return `${nearestHundreths(sizeInBytes, GB)} GB`;
  }
  if (sizeInBytes >= 100 * MB) {
    return `${nearestWhole(sizeInBytes, MB)} MB`;
  }
  return `${nearestTenths(sizeInBytes, MB)} MB`;
}